import {
  call, put, takeLatest, select,
} from 'redux-saga/effects';
import { stopSubmit, change } from 'redux-form';
import { callApi } from './loadingSaga';
import Api from '../api/mypageApi';
import * as Actions from '../actions/mypageActions';

export function* absent(action) {
  const { success } = yield call(callApi, Api.absentWithNotice, action.payload.id, action.payload.absence_reason_id, action.payload.absence_reason_comment);
  if (success) {
    yield put(Actions.setAbsentSucceed(true));
    const { absenceReasons, schoolAttendances } = yield select((state) => state.mypage);
    const school_attendance = schoolAttendances.find((x) => x.id === action.payload.id);
    yield put(Actions.updateSchoolAttendance({
      ...school_attendance,
      reason: absenceReasons.find((x) => x.id === action.payload.absence_reason_id).reason,
      status_string: '事前欠席',
      comment: action.payload.absence_reason_comment,
      tooltip: false,
    }));
    yield put(change('schoolAttendanceModal', 'absence_reason_id', null));
  }
  yield put(stopSubmit('schoolAttendanceModal'));
}

export function* schoolXAbsent(action) {
  const { preAbsence } = yield call(callApi, Api.schoolXAbsentWithNotice, action.payload.id, action.payload.absence_reason_id, action.payload.absence_reason_comment);
  yield put(Actions.setAbsentSucceed(true));
  const { absenceReasons, schoolXAttendances } = yield select((state) => state.mypage);
  const school_attendance = schoolXAttendances.find((x) => x.id === action.payload.id);
  yield put(Actions.updateSchoolXAttendance({
    ...school_attendance,
    pre_absence: preAbsence,
    reason: absenceReasons.find((x) => x.id === action.payload.absence_reason_id).reason,
    comment: action.payload.absence_reason_comment,
    tooltip: false,
  }));
  yield put(change('schoolAttendanceModal', 'absence_reason_id', null));
  yield put(stopSubmit('schoolAttendanceModal'));
}

export function* cancelAbsent(action) {
  const { success } = yield call(callApi, Api.cancelAbsentWithNotice, action.payload.id);
  if (success) {
    yield put(Actions.toggleCancelAbsentSucceedModal());
    const { schoolAttendances } = yield select((state) => state.mypage);
    const school_attendance = schoolAttendances.find((x) => x.id === action.payload.id);
    yield put(Actions.updateSchoolAttendance({
      ...school_attendance,
      status_string: '出席予定',
      reason: null,
      comment: '',
      tooltip: false,
    }));
  }
  yield put(Actions.setCancelAbsentSubmitting(false));
}

export function* schoolXCancelAbsent(action) {
  const { success } = yield call(callApi, Api.schoolXCancelAbsentWithNotice, action.payload.id);
  if (success) {
    yield put(Actions.toggleCancelAbsentSucceedModal());
    const { schoolXAttendances } = yield select((state) => state.mypage);
    const school_attendance = schoolXAttendances.find((x) => x.id === action.payload.id);
    yield put(Actions.updateSchoolXAttendance({
      ...school_attendance,
      pre_absence: 'not',
      reason: null,
      comment: '',
      tooltip: false,
    }));
  }
  yield put(Actions.setCancelAbsentSubmitting(false));
}

export function* addSchoolExtraClass(action) {
  const { success } = yield call(callApi, Api.addSchoolExtraClass, action.payload.id, action.payload.school_extra_class_id);
  if (success) {
    yield put(Actions.setAddSchoolExtraClassSucceed(true));
    const { preAbsences } = yield select((state) => state.mypage);
    yield put(Actions.updateSchoolExtraClass({
      id: action.payload.school_extra_class_id,
      status_string: '参加登録済',
      absent_date: preAbsences.find((x) => x.id === action.payload.id).date_time,
      added_school_attendance_id: action.payload.id,
    }));
    yield put(Actions.updatePreAbsence({
      id: action.payload.id,
      disabled: true,
    }));
    yield put(change('schoolExtraClassModal', 'id', undefined));
  }
  yield put(stopSubmit('schoolExtraClassModal'));
}

export function* cancelSchoolExtraClass(action) {
  const { success } = yield call(callApi, Api.cancelExtraClass, action.payload.id);
  if (success) {
    yield put(Actions.toggleCancelExtraClassSucceedModal());
    yield put(Actions.updateSchoolExtraClass({
      id: action.payload.schoolExtendClassId,
      status_string: '登録可', // TODO: サーバーから取得
      date_time: action.payload.date_time,
      absent_date: null,
      added_school_attendance_id: null,
    }));
    yield put(Actions.updatePreAbsence({
      id: action.payload.id,
      disabled: false,
    }));
  }
  yield put(Actions.setCancelSchoolExtraClassSubmitting(false));
}

export function* onChangeFormInput(action) {
  const { form, field } = action.meta;
  if (form === 'schoolAttendanceModal' && field === 'absence_reason_id') {
    if (action.payload === 8) {
      yield put(Actions.setOpenCommentForm(true));
    } else {
      yield put(Actions.setOpenCommentForm(false));
    }
  }
}

export default function* mypageSaga() {
  yield takeLatest(Actions.SAGA_ABSENT, absent);
  yield takeLatest(Actions.SAGA_SCHOOL_X_ABSENT, schoolXAbsent);
  yield takeLatest(Actions.SAGA_CANCEL_ABSENT, cancelAbsent);
  yield takeLatest(Actions.SAGA_SCHOOL_X_CANCEL_ABSENT, schoolXCancelAbsent);
  yield takeLatest('@@redux-form/CHANGE', onChangeFormInput);
  yield takeLatest(Actions.SAGA_ADD_SCHOOL_EXTRA_CLASS, addSchoolExtraClass);
  yield takeLatest(Actions.SAGA_CANCEL_EXTRA_CLASS, cancelSchoolExtraClass);
}
